export default __webpack_public_path__ + "static/media/avatar_trex1.d28cf459.mp3";